module.exports = __webpack_public_path__ + "img/Utilize1.e6b219a5.png";